import { theme } from '@hackclub/design-system'

// change things

export default theme



// WEBPACK FOOTER //
// ./src/theme/config.js